import { render } from "./CompanyClaimAddModal.vue?vue&type=template&id=565debee"
import script from "./CompanyClaimAddModal.vue?vue&type=script&lang=js"
export * from "./CompanyClaimAddModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__